import { render, staticRenderFns } from "./EsPrivacyPolicy.vue?vue&type=template&id=93c29632&scoped=true"
import script from "./EsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./EsPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "93c29632",
  null
  ,true
)

export default component.exports